// import baseUrl from '@/api/baseUrl'
// export default baseUrl+'/sys'

export default '/api'